import { Box } from "@mui/material";

import Container from "./Container";

const Footer = () => (
  <Box
    sx={{
      backgroundColor: "white",
      paddingY: "1em",
      textAlign: "right",
      minHeight: "4em",
      "& a": {
        color: "primary.main",
      },
    }}
  >
    <Container
      sx={{
        justifyContent: "space-between",
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
      }}
    >
      <div>
        Ontwikkeld in samenwerking met{" "}
        <a href="https://degoedezaak.org" rel="noreferrer" target="_blank">
          DeGoedeZaak
        </a>
      </div>
      <div>
        Huisstijl door{" "}
        <a href="https://trueshift.nl" rel="noreferrer" target="_blank">
          TrueShift
        </a>
      </div>
    </Container>
  </Box>
);

export default Footer;
